import React from "react";
import SelectField from "./SelectField";

interface StaffRelationshipFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  className?: string;
}

// Staff Emergency Contact Relationship options
const relationshipOptions = [
  { value: "spouse", label: "Spouse/Partner" },
  { value: "parent", label: "Parent" },
  { value: "sibling", label: "Sibling" },
  { value: "child", label: "Child" },
  { value: "grandparent", label: "Grandparent" },
  { value: "grandchild", label: "Grandchild" },
  { value: "aunt_uncle", label: "Aunt/Uncle" },
  { value: "cousin", label: "Cousin" },
  { value: "in_law", label: "In-Law" },
  { value: "friend", label: "Friend" },
  { value: "neighbor", label: "Neighbor" },
  { value: "coworker", label: "Coworker" },
  { value: "roommate", label: "Roommate" },
  { value: "caregiver", label: "Caregiver" },
  { value: "other_family", label: "Other Family Member" },
  { value: "other", label: "Other" }
];

const StaffRelationshipField: React.FC<StaffRelationshipFieldProps> = ({
  id,
  name,
  value,
  onChange,
  label = "Relationship to Staff Member",
  placeholder = "Select relationship",
  required = false,
  error = false,
  hint,
  className = "",
}) => {
  return (
    <div className={className}>
      <SelectField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        error={error}
        hint={hint}
        options={relationshipOptions}
      />
    </div>
  );
};

export default StaffRelationshipField; 